import { BarChart3, Building2, CalendarDays, CalendarRange, Gauge, LayoutGrid, Users, DoorOpen, Send, FileText, History, Settings, ClipboardList, Hotel, Phone, Printer, Receipt, Sparkles, type LucideIcon } from 'lucide-react';
const ICONS: Record<string, LucideIcon> = {
  calendar: CalendarDays, building: Building2, gauge: Gauge, board: LayoutGrid, guests: Users, desk: DoorOpen,
  messages: Send, registration: ClipboardList, outputs: Printer, activity: History, settings: Settings, hotel: Hotel, doc: FileText, money: Receipt, nights: CalendarRange, reports: BarChart3, assistant: Sparkles, phone: Phone,
};
export function NavIcon({ name, className }: { name: string; className?: string }) {
  const I = ICONS[name] ?? FileText;
  return <I className={className ?? 'size-4'} aria-hidden />;
}
